import { useEffect, useState } from "react";
import Input from "shared/Input/Input";
import MultiSelectDropdown from "shared/MultiSelectDropdown"
import FormItem from "./FormItem";
import Textarea from "shared/Textarea/Textarea";
import { connect, useDispatch } from "react-redux";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import { Grid2 as Grid } from "@mui/material";
import api from '../../api';
import Snackbar from '@mui/material/Snackbar';
import { Alert } from "@mui/material";
import { updateUserBrand } from "../../redux/reducers/userReducer";
import _ from 'lodash';

const BrandBasicInfoSection = ({ selectedBrand, formoptions }) => {
  const dispatch = useDispatch();

  const initialValues = {
    name: selectedBrand.name,
    country: null,
    description: selectedBrand.description,
    website: selectedBrand.website,
    instagram: selectedBrand.instagram,
    linkedin: selectedBrand.linkedin,
    contact_person_name: selectedBrand.contact_person_name,
    contact_person_email: selectedBrand.contact_person_email,
    contact_person_phone: selectedBrand.contact_person_phone,
    regions: selectedBrand.regions,
  }
  const [inputValues, setInputValues] = useState(initialValues);

  const [sbState, setSBState] = useState({
    open: false,
  });
  const { open } = sbState;

  useEffect(() => {
    const tempBrandData = _.cloneDeep(selectedBrand);
    tempBrandData.country = tempBrandData.country && JSON.parse(tempBrandData.country).map((val) => { return { label: val, value: val } });
    setInputValues(tempBrandData);
  }, [selectedBrand]);

  const handleInputChange = (e) => {
    setInputValues((prevState) => ({
      ...prevState,
      [e.target.name]: e.target.value,
    }));
  };

  const handleCountryChange = (e) => {
    setInputValues((prevState) => ({
      ...prevState,
      country: e,
    }));
  }


  const handleUpdateBrand = () => {
    const payload = {
      id: selectedBrand.id,
      name: inputValues.name,
      country: null,
      description: inputValues.description,
      website: inputValues.website,
      instagram: inputValues.instagram,
      linkedin: inputValues.linkedin,
      contact_person_name: inputValues.contact_person_name,
      contact_person_email: inputValues.contact_person_email,
      contact_person_phone: inputValues.contact_person_phone,
      region_presences: inputValues.regions,
    }

    if (inputValues?.country?.length > 0) {
      payload.country = JSON.stringify(inputValues.country.map((val) => { return val.value }));

      // remove regions not included in the country
      const ids = inputValues.country.map(item => item.value);

      payload.region_presences = inputValues.regions
        .filter(item => ids.includes(item.country))
        .map(item => item.region_id);
    }

    api.updateBrand(payload, (res) => {
      if (res.status === 200) {
        dispatch(updateUserBrand(res.data));
        openSuccessSnackbar(true);
      }
    });
  }

  const openSuccessSnackbar = (position) => {
    setSBState({ ...position, open: true });
  }

  const handleCloseSB = () => {
    setSBState({ ...sbState, open: false });
  }

  return (
    <>
      {/* FORM */}
      <div className="space-y-8">
        <FormItem
          label="Brand Name"
        >
          <Input
            placeholder="Brand Name"
            name='name'
            value={inputValues?.name ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>

        <FormItem
          label="Brand Profile Info"
        >
          <Textarea
            name="description"
            rows={5}
            value={inputValues?.description ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>

        <h2 className="text-xl font-semibold">Country</h2>
        <FormItem
          label="Country"
        >
          <MultiSelectDropdown
            options={formoptions?.countries?.map((cnt) => { return { label: cnt, value: cnt } })}
            onChange={handleCountryChange}
            value={inputValues?.country ?? []}
          />
        </FormItem>
        <h2 className="text-xl font-semibold">Website & Social Links</h2>
        <FormItem
          label="Website"
        >
          <Input
            placeholder="Website"
            name='website'
            value={inputValues?.website ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem
          label="Instagram"
        >
          <Input
            placeholder="Instagram"
            name='instagram'
            value={inputValues?.instagram ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem
          label="LinkedIn"
        >
          <Input
            placeholder="LinkedIn"
            name='linkedin'
            value={inputValues?.linkedin ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>

        <h2 className="text-xl font-semibold">Contact Person</h2>
        <FormItem>
          <Input
            placeholder="Name"
            name='contact_person_name'
            value={inputValues?.contact_person_name ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem>
          <Input
            placeholder="Email"
            name='contact_person_email'
            value={inputValues?.contact_person_email ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>
        <FormItem>
          <Input
            placeholder="Phone"
            name='contact_person_phone'
            value={inputValues?.contact_person_phone ?? ""}
            onChange={handleInputChange}
          />
        </FormItem>

        <Grid container direction={'row'} className={'fullWidth'}>
          <div className={'flex-1'}></div>
          <ButtonPrimary onClick={handleUpdateBrand}>Save Changes</ButtonPrimary>
        </Grid>
      </div>
      <Snackbar
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        open={open}
        autoHideDuration={5000}
        onClose={handleCloseSB}
        message="Basic Info Details Updated"
      >
        <Alert
          onClose={handleCloseSB}
          severity="success"
          variant="filled"
          sx={{ width: '100%' }}
        >
          Basic Info Details Updated!
        </Alert>
      </Snackbar>
    </>
  );
};

const mapStateToProps = (state) => ({
  formoptions: state.formoptions.options,
});

export default connect(mapStateToProps, { updateUserBrand })(
  BrandBasicInfoSection
);
